<template>
  <div class="sidebar-left">
    <!-- <h1 class="title">MarkDrop</h1> -->
    <!-- <h1 class="title">MDEditorsy</h1> -->
    <div style="display: flex; justify-content: center">
      <img src="../assets/MDE.png" style="width: 40%" alt="" srcset="" />
    </div>
    <h1 class="title">v0.0.1</h1>
    <div class="sidebar-container">
      <accordion
        v-for="(group, i) in groups"
        :key="i"
        :title="group.name"
        :blocks="group.blocks"
      />
    </div>
  </div>
</template>

<script>
import Accordion from "./Accordion.vue";
import groups from "../utils/blocks";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { Accordion },
  name: "SideBarLeft",
  props: {},
  data() {
    return {
      groups,
    };
  },
  computed: {
    ...mapGetters(["selectedElement"]),
  },
  methods: {
    handleInput(e) {
      // do some things
      console.log(e);
      this.setElementValueById(e);
    },
    ...mapActions(["setElementValueById"]),
  },
};
</script>

<style lang="scss" scoped>
@import "~easymde/dist/easymde.min.css";

.sidebar-left {
  width: 19em;
  background-color: #494647;
  height: 100%;
  flex-shrink: 0;
  overflow: hidden;
}

.title {
  font-size: 1rem;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-weight: 500;
  color: white;
  // border-bottom: 1px solid #15151554;
  text-align: center;
  height: 2.2rem;
}

.sidebar-container {
  height: calc(100% - 2.2rem);
  overflow: auto;
  border-bottom: 1px solid #0000008c;
}
</style>
